/**
 * Centralized localStorage key names to avoid magic strings scattered across files.
 * If a key name changes, it only needs to be updated here.
 */
export const STORAGE_KEYS = {
    /** Set during registration if the user opted into marketing consent; flushed on next login. */
    pendingMarketingConsent: 'pendingMarketingConsent',
    /**
     * Impersonation session metadata (while an admin is impersonating a customer on
     * the headless storefront). JSON: { targetCustomerId, targetDisplayName,
     * targetEmail, adminId, adminBaseUrl, expiresAt }.
     */
    impersonation: 'impersonation',
} as const;